<h3>Filtrar por modelos</h3>
<mat-dialog-content>
    <mat-form-field appearance="standard">
        <mat-label>Modelos</mat-label>
        <mat-select [(ngModel)]="modelosField" #modelosSelect multiple>
            <mat-option *ngFor="let modelo of modelos.registros; let i = index;" [value]="modelo.idmodelo">{{ modelo.marca_modelo }}</mat-option>
            <div class="position-sticky bottom-0 start-50 p-2 bg-white d-flex justify-content-center">
                <button mat-raised-button color="accent" (click)="modelosSelect.close()">Aceptar</button>
            </div>
        </mat-select>
    </mat-form-field>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-raised-button color="accent" (click)="aceptarModelos()">Aceptar</button>
    <button mat-raised-button color="warn" mat-dialog-close>Cancelar</button>
</mat-dialog-actions>